// src/hooks/useDetectMobileView.js
import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { setIsMobileView } from '../redux/appConfigInfo';

export default function useDetectMobileView() {
  const dispatch = useDispatch()

  useEffect(() => {
    const handleResize = () => {
      dispatch(setIsMobileView(window.innerWidth <= 768))
    }

    handleResize() // Run initially on mount
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [dispatch])
}
